module.exports = __webpack_public_path__ + "img/cragheart.520e2255.png";